import React, { useEffect, useState } from "react";
import { ExternalLink, ChevronDown } from "lucide-react";

const API = process.env.API_URL || "http://localhost:4000/api";
const IMPORTANT = /^(8-K|DEF 14A|S-1|S-3|424B|6-K|SC 13|SCHEDULE 13)/i;
const MON = ["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"];
const fd = (d) => (d ? +d.slice(8, 10) + " " + MON[+d.slice(5, 7) - 1] + " " + d.slice(0, 4) : "");

function Card({ title, right, children }) {
  return (
    <div className="dp-card">
      <div className="dp-title"><h4>{title}</h4>{right}</div>
      {children}
    </div>
  );
}
function Body({ children, empty }) {
  return (
    <div className="dp-body">
      {children}
      {empty && <div className="text-muted small">Nothing found.</div>}
    </div>
  );
}
function Item({ href, title, sub }) {
  return (
    <div className="dp-item">
      {href ? <a href={href} target="_blank" rel="noreferrer">{title}</a> : <span>{title}</span>}
      {sub && <div className="dp-sub">{sub}</div>}
    </div>
  );
}

export default function DocumentsPanel({ ticker }) {
  const [d, setD] = useState(null);
  const [rel, setRel] = useState(null);
  const [tab, setTab] = useState("recent");
  const [q, setQ] = useState("");
  useEffect(() => {
    if (!ticker) return;
    let on = true;
    setD(null); setRel(null);
    fetch(`${API}/stocks/${ticker}/documents`).then((r) => r.json()).then((j) => on && setD(j)).catch(() => on && setD({ announcements: [], annual: [], quarterly: [] }));
    fetch(`${API}/stocks/${ticker}/releases`).then((r) => r.json()).then((j) => on && setRel(Array.isArray(j) ? j : (j.items || j.releases || []))).catch(() => on && setRel([]));
    return () => { on = false; };
  }, [ticker]);

  if (!d) return <div className="text-muted">Loading...</div>;
  let ann = d.announcements;
  if (tab === "recent") ann = ann.slice(0, 25);
  else if (tab === "important") ann = ann.filter((r) => IMPORTANT.test(r.form));
  else if (tab === "search") { const s = q.toLowerCase(); ann = s ? ann.filter((r) => ((r.form || "") + " " + (r.description || "")).toLowerCase().includes(s)) : ann.slice(0, 25); }
  const edgar = `https://www.sec.gov/cgi-bin/browse-edgar?action=getcompany&CIK=${ticker}&type=&dateb=&owner=include&count=40`;

  return (
    <div className="dp-grid">
      <Card title="Announcements">
        <div className="dp-tabs">
          {[["recent", "Recent"], ["important", "Important"], ["search", "Search"]].map(([k, l]) => (
            <button key={k} className={tab === k ? "on" : ""} onClick={() => setTab(k)}>{l}</button>
          ))}
          <button className={tab === "all" ? "on" : ""} onClick={() => setTab("all")}>All</button>
          <a href={edgar} target="_blank" rel="noreferrer" title="Open on SEC EDGAR"><ExternalLink size={12} /></a>
        </div>
        {tab === "search" && <input className="dp-search" placeholder="Search filings..." value={q} onChange={(e) => setQ(e.target.value)} />}
        <Body empty={!ann.length}>
          {ann.map((r, i) => <Item key={i} href={r.url} title={r.form + (r.description ? " - " + r.description : "")} sub={fd(r.filed)} />)}
        </Body>
      </Card>
      <Card title="Annual reports">
        <Body empty={!d.annual.length}>
          {d.annual.map((r, i) => <Item key={i} href={r.url} title={"Annual Report " + (r.filed || "").slice(0, 4) + " (" + r.form + ")"} sub={"filed " + fd(r.filed) + " from SEC"} />)}
        </Body>
      </Card>
      <Card title="Quarterly reports">
        <Body empty={!d.quarterly.length}>
          {d.quarterly.map((r, i) => <Item key={i} href={r.url} title={"Quarterly Report (" + r.form + ")"} sub={"filed " + fd(r.filed) + " from SEC"} />)}
        </Body>
      </Card>
      <Card title="Earnings releases">
        {!rel && <div className="text-muted small">Loading...</div>}
        {rel && (
          <Body empty={!rel.length}>
            {rel.map((r, i) => (
              <Item key={i} href={r.url || r.link} title={r.title || r.name || r.description || "Earnings release"} sub={fd((r.date || r.filed || "").slice(0, 10))} />
            ))}
          </Body>
        )}
      </Card>
    </div>
  );
}